// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settingsContainer {
  display: flex;
  justify-content: center;
}

.settingsItem {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 25px;
}

.title {
  margin-bottom: 50px;
}

.custom-select {
  width: 250px;
  height: 40px;
  border-radius: 5px;
  margin-bottom: 20px;
  cursor: pointer;
}

.delete-shop-button {
  border: none;
  background-color: transparent;
  cursor: pointer;
  border-left: 1px solid grey;
}

.shop-list {
  width: 80%;
  margin: 10px auto;
  overflow: auto;
  padding: 0;
  scrollbar-width: thin;
}

.shop-list li {
  list-style-type: none;
  padding: 5px 10px;
  justify-content: space-between;
  display: flex;
  margin-bottom: 5px;
}

.card-li {
  margin-bottom: 5px;
}

.form-label {
  margin-top: 0.5rem;
}

::-webkit-scrollbar {
  height: 12px;
  width: 6px;
  background: rgb(255, 255, 255);
}

::-webkit-scrollbar-thumb {
  background: rgb(160, 160, 160);
  -webkit-border-radius: 1ex;
  -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.75);
}

::-webkit-scrollbar-corner {
  background: #000;
}

@media screen and (max-width: 1100px) {
  .settingsContainer {
    flex-wrap: wrap;
  }
}
@media screen and (max-width: 50em) {
  .Logo2bad-login{
	width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/AdminSettings.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;CACD,WAAW;EACV;AACF","sourcesContent":[".settingsContainer {\n  display: flex;\n  justify-content: center;\n}\n\n.settingsItem {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  padding: 25px;\n}\n\n.title {\n  margin-bottom: 50px;\n}\n\n.custom-select {\n  width: 250px;\n  height: 40px;\n  border-radius: 5px;\n  margin-bottom: 20px;\n  cursor: pointer;\n}\n\n.delete-shop-button {\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n  border-left: 1px solid grey;\n}\n\n.shop-list {\n  width: 80%;\n  margin: 10px auto;\n  overflow: auto;\n  padding: 0;\n  scrollbar-width: thin;\n}\n\n.shop-list li {\n  list-style-type: none;\n  padding: 5px 10px;\n  justify-content: space-between;\n  display: flex;\n  margin-bottom: 5px;\n}\n\n.card-li {\n  margin-bottom: 5px;\n}\n\n.form-label {\n  margin-top: 0.5rem;\n}\n\n::-webkit-scrollbar {\n  height: 12px;\n  width: 6px;\n  background: rgb(255, 255, 255);\n}\n\n::-webkit-scrollbar-thumb {\n  background: rgb(160, 160, 160);\n  -webkit-border-radius: 1ex;\n  -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.75);\n}\n\n::-webkit-scrollbar-corner {\n  background: #000;\n}\n\n@media screen and (max-width: 1100px) {\n  .settingsContainer {\n    flex-wrap: wrap;\n  }\n}\n@media screen and (max-width: 50em) {\n  .Logo2bad-login{\n\twidth: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
